const getAPIUrl = () => process.env.REACT_APP_API_URL;

export default getAPIUrl;
